import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from '@angular/core'
import { ImageUrlPipe } from '../../@core/pipes/pipes/image-url.pipe'
import { LocalStorageService } from '../../@core/utils'
import { ChooseAvatarComponent } from '../choose-avatar/choose-avatar.component'
import { NbDialogRef, NbDialogService } from '@nebular/theme'
import { NavigationStart, Router, RouterEvent } from '@angular/router'
import { filter } from 'rxjs/operators'

export enum PvsAvatarFrameStyle {
    ROUND,
    RECTANGLE,
}

@Component({
    templateUrl: './full-size-avatar.component.html',
    styleUrls: ['./full-size-avatar.component.scss'],
    selector: 'app-full-size-avatar',
})
export class FullSizeAvatarComponent implements OnChanges, OnInit {
    PvsAvatarFrameStyle = PvsAvatarFrameStyle

    @Input() avatarUrl: string
    @Input() avatarHdUrl: string

    @Input() editable: boolean = false

    @Input() file: File
    @Output() fileChange: EventEmitter<File> = new EventEmitter()

    @Input() frameStyle: PvsAvatarFrameStyle = PvsAvatarFrameStyle.ROUND
    @Input() ratio: number = 3 / 4
    @Input() resizeToWidth: number = 1200

    @ViewChild(ChooseAvatarComponent) fileInput: ChooseAvatarComponent
    @ViewChild('dialog', { static: true }) dialog: TemplateRef<any>

    styleImage: string
    styleImageHd: string
    imageBase64: any = null
    allowAvatarClick: boolean = false
    imgWidth: number = 10
    imgHeight: number = 10

    _routerSubscription
    dialogRef: NbDialogRef<any>

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private dialogService: NbDialogService
    ) {}

    ngOnInit(): void {
        this._routerSubscription = this.router.events
            .pipe(
                filter((event: RouterEvent) => event instanceof NavigationStart),
                filter(() => !!this.dialogRef)
            )
            .subscribe(() => {
                this.dialogRef.close()
            })
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.frameStyle === PvsAvatarFrameStyle.RECTANGLE) {
            if (this.ratio < 1) {
                this.imgWidth = 10
                this.imgHeight = Math.round(this.imgWidth / this.ratio)
            } else {
                this.imgHeight = 10
                this.imgWidth = Math.round(this.imgHeight * this.ratio)
            }
        }
        this.getStyleImage()
    }

    getStyleImage() {
        if (this.file && this.imageBase64) {
            this.styleImage = `url('${this.imageBase64}')`
            this.styleImageHd = this.imageBase64
            this.allowAvatarClick = true
        } else {
            let url = this.avatarUrl
            if (!url || typeof url !== 'string') {
                // set default avatar
                url = 'general%2Fdefault_user_avatar_3.png'
                url = new ImageUrlPipe(this.localStorageService).transform(url)
            }
            this.styleImage = `url('${url}')`
            //
            this.allowAvatarClick = true
            let urlHd = this.avatarHdUrl || this.avatarUrl
            if (!urlHd || typeof urlHd !== 'string') {
                this.allowAvatarClick = false
                // set default avatar
                urlHd = 'general%2Fdefault_user_avatar_3.png'
                urlHd = new ImageUrlPipe(this.localStorageService).transform(urlHd)
            }
            this.styleImageHd = urlHd
        }
    }

    onFileClicked(e) {
        console.log('button clicked')
        this.fileInput.click()
    }

    onAvatarClicked(event) {
        console.log('avatar clicked')
        if (!this.allowAvatarClick) {
            return
        }
        this.dialogRef = this.dialogService.open(this.dialog)
    }

    fileChanged(event) {
        this.file = event
        this.fileChange.emit(this.file)
        const reader = new FileReader()
        reader.readAsDataURL(event)

        reader.onload = (progressEvent) => {
            this.imageBase64 = progressEvent.target.result
            console.log('loaded')
            this.getStyleImage()
        }
    }
}
